const FilterDropdownType = Object.freeze({
  INPUT: 'input',
  CHECKBOX: 'checkbox',
  MULTISELECT: 'multiselect',
})

export default FilterDropdownType